<template>
  <div>
    <div class="container">
      <loading
        :active.sync="isLoading"
        :loader="'dots'"
        :color="'#FFF'"
        :background-color="'#000'"
        :can-cancel="false"
        :is-full-page="true"
      />
      <h1 class="pb-2 mt-4 mb-2 border-bottom">{{ $t(pageTitle) }}</h1>
      <p v-html="$t(messages.header)"></p>

      <div>
        <div class="card">
          <div class="card-header">{{ $t('ご契約情報') }}</div>
          <div class="card-body">
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">{{
                $t('ご利用アプリ')
              }}</label>
              <div class="col-sm-9">
                <div v-if="!isFree">
                  <div class="mb-4">
                    <div v-if="!isPurchaseTrial" class="input-group">
                      <div
                        class="form-check form-check-inline"
                        :class="{ 'is-invalid': create.error.isUseSmallLot }"
                      >
                        <input
                          type="checkbox"
                          id="isUseSmallLot"
                          class="form-check-input"
                          v-model="create.isUseSmallLot"
                          :disabled="create.confirm"
                          :class="{
                            'is-invalid':
                              create.error.isUseSmallLot || create.error.isUse,
                          }"
                        />
                        <label for="isUseSmallLot" class="form-check-label">{{
                          $t('工程管理')
                        }}</label>
                      </div>
                      <div class="invalid-feedback">
                        {{ create.error.isUseSmallLot }}
                      </div>
                    </div>
                    <div v-if="!isPurchaseTrial" class="input-group">
                      <div
                        class="form-check form-check-inline"
                        :class="{ 'is-invalid': create.error.isUseInventory }"
                      >
                        <input
                          type="checkbox"
                          id="isUseInventory"
                          class="form-check-input"
                          v-model="create.isUseInventory"
                          :disabled="create.confirm"
                          :class="{
                            'is-invalid':
                              create.error.isUsePurchase || create.error.isUse,
                          }"
                        />
                        <label for="isUseInventory" class="form-check-label">{{
                          $t('在庫管理')
                        }}</label>
                      </div>
                      <div class="invalid-feedback">
                        {{ create.error.isUseInventory }}
                      </div>
                    </div>
                    <div class="input-group">
                      <div
                        class="form-check form-check-inline"
                        :class="{ 'is-invalid': create.error.isUsePurchase }"
                      >
                        <input
                          type="checkbox"
                          id="isUsePurchase"
                          class="form-check-input"
                          v-model="create.isUsePurchase"
                          :disabled="create.confirm"
                          :class="{
                            'is-invalid':
                              create.error.isUsePurchase || create.error.isUse,
                          }"
                        />
                        <label for="isUsePurchase" class="form-check-label">{{
                          $t('受発注管理')
                        }}</label>
                      </div>
                      <div class="invalid-feedback">
                        {{ create.error.isUsePurchase }}
                      </div>
                    </div>
                    <input
                      type="hidden"
                      :class="{ 'is-invalid': create.error.isUse }"
                    />
                    <div class="invalid-feedback">{{ create.error.isUse }}</div>
                  </div>
                </div>
                <div v-if="isFree && !isPurchaseTrial">
                  <div class="mb-4">
                    <div class="col-form-label">
                      {{ $t('図面/標準工程管理アプリ') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-4">
          <div class="card-header">{{ $t('アカウント情報') }}</div>
          <div class="card-body">
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">
                {{ $t('メールアドレス') }}
                <span class="text-danger">{{ $t('必須') }}</span>
              </label>
              <div class="col-sm-9">
                <div class="input-group" v-if="!create.confirm">
                  <input
                    type="email"
                    class="form-control"
                    :placeholder="$t('info@mono-revo.co.jp')"
                    maxlength="254"
                    required
                    v-model="create.uid"
                    :class="{
                      'is-invalid': create.error.uid,
                    }"
                  />
                  <div class="invalid-feedback">{{ create.error.uid }}</div>
                </div>
                <div class="col-form-label" v-if="create.confirm">
                  {{ create.uid }}
                </div>
              </div>
            </div>
            <div class="form-group row" v-if="!create.confirm">
              <label class="col-sm-3 col-form-label">
                {{ $t('メールアドレス(確認)') }}
                <span class="text-danger">{{ $t('必須') }}</span>
              </label>
              <div class="col-sm-9">
                <div class="input-group" v-if="!create.confirm">
                  <input
                    type="email"
                    class="form-control"
                    :placeholder="$t('info@mono-revo.co.jp')"
                    maxlength="254"
                    required
                    v-model="create.uidConfirm"
                    :class="{
                      'is-invalid': create.error.uidConfirm,
                    }"
                  />
                  <div class="invalid-feedback">
                    {{ create.error.uidConfirm }}
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">
                {{ $t('ログインID') }}
                <span class="text-danger">{{ $t('必須') }}</span>
              </label>
              <div class="col-sm-9">
                <div class="input-group" v-if="!create.confirm">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="32"
                    required
                    v-model="create.loginId"
                    :class="{
                      'is-invalid': create.error.loginId,
                    }"
                  />
                  <div class="invalid-feedback">{{ create.error.loginId }}</div>
                </div>
                <div class="col-form-label" v-if="create.confirm">
                  {{ create.loginId }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">
                {{ $t('パスワード') }}
                <span class="text-danger">{{ $t('必須') }}</span>
              </label>
              <div class="col-sm-9">
                <div class="input-group" v-if="!create.confirm">
                  <input
                    type="password"
                    class="form-control"
                    required
                    v-model="create.password"
                    :class="{
                      'is-invalid': create.error.password,
                    }"
                  />
                  <div class="invalid-feedback">
                    {{ create.error.password }}
                  </div>
                </div>
                <div class="col-form-label" v-if="create.confirm">
                  {{ '*'.repeat(create.password.length) }}
                </div>
              </div>
            </div>
            <div class="form-group row" v-if="!create.confirm">
              <label class="col-sm-3 col-form-label">
                {{ $t('パスワード(確認)') }}
                <span class="text-danger">{{ $t('必須') }}</span>
              </label>
              <div class="col-sm-9">
                <div class="input-group" v-if="!create.confirm">
                  <input
                    type="password"
                    class="form-control"
                    required
                    v-model="create.passwordConfirm"
                    :class="{
                      'is-invalid': create.error.passwordConfirm,
                    }"
                  />
                  <div class="invalid-feedback">
                    {{ create.error.passwordConfirm }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-4">
          <div class="card-header">{{ $t('請求先情報') }}</div>
          <div class="card-body">
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">{{
                $t('クーポンコード')
              }}</label>
              <div class="col-sm-9">
                <div class="input-group" v-if="!create.confirm">
                  <input
                    type="text"
                    class="form-control"
                    v-model="create.coupon"
                    :class="{
                      'is-invalid': create.error.coupon,
                    }"
                  />
                  <div class="invalid-feedback">{{ create.error.coupon }}</div>
                </div>
                <div class="col-form-label" v-if="create.confirm">
                  {{ create.coupon }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">
                {{ $t('国') }}
                <span class="text-danger">{{ $t('必須') }}</span>
              </label>
              <div class="col-sm-9">
                <div class="input-group" v-if="!create.confirm">
                  <select
                    class="form-control"
                    required
                    v-model="create.countryCode"
                    :class="{
                      'is-invalid': create.error.countryCode,
                    }"
                  >
                    <template>
                      <option
                        v-for="(item, index) in country"
                        :key="index"
                        :value="item.code"
                        >{{ $t(item.name) }}</option
                      >
                    </template>
                  </select>
                  <div class="invalid-feedback">
                    {{ create.error.countryCode }}
                  </div>
                </div>
                <div class="col-form-label" v-if="create.confirm">
                  {{ $t(getCountryName(create)) }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">
                {{ $t('会社名') }}
                <span class="text-danger">{{ $t('必須') }}</span>
              </label>
              <div class="col-sm-9">
                <div class="input-group" v-if="!create.confirm">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('ものレボ株式会社')"
                    maxlength="128"
                    required
                    v-model="create.name"
                    :class="{
                      'is-invalid': create.error.name,
                    }"
                  />
                  <div class="invalid-feedback">{{ create.error.name }}</div>
                </div>
                <div class="col-form-label" v-if="create.confirm">
                  {{ create.name }}
                </div>
              </div>
            </div>
            <div class="form-group row" v-if="create.countryCode === 'JP'">
              <label class="col-sm-3 col-form-label">
                {{ $t('フリガナ') }}
                <span class="text-danger">{{ $t('必須') }}</span>
              </label>
              <div class="col-sm-9">
                <div class="input-group" v-if="!create.confirm">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('モノレボカブシキガイシャ')"
                    maxlength="200"
                    v-model="create.kana"
                    :required="create.countryCode === 'JP'"
                    :class="{
                      'is-invalid': create.error.kana,
                    }"
                  />
                  <div class="invalid-feedback">{{ create.error.kana }}</div>
                </div>
                <div class="col-form-label" v-if="create.confirm">
                  {{ create.kana }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">
                {{ $t('郵便番号') }}
                <span class="text-danger">{{ $t('必須') }}</span>
              </label>
              <div class="col-sm-9">
                <div class="input-group" v-if="!create.confirm">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('604-8206')"
                    maxlength="20"
                    required
                    v-model="create.zipcode"
                    :class="{
                      'is-invalid': create.error.zipcode,
                    }"
                  />
                  <div class="invalid-feedback">{{ create.error.zipcode }}</div>
                </div>
                <div class="col-form-label" v-if="create.confirm">
                  {{ create.zipcode }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">
                {{ create.countryCode === 'JP' ? $t('都道府県') : $t('州') }}
                <span class="text-danger">{{ $t('必須') }}</span>
              </label>
              <div class="col-sm-9">
                <div class="input-group" v-if="!create.confirm">
                  <select
                    class="form-control"
                    required
                    v-model="create.prefCode"
                    :class="{
                      'is-invalid': create.error.prefCode,
                    }"
                  >
                    <template v-if="create.countryCode">
                      <option
                        v-for="(item, index) in pref[create.countryCode]"
                        :key="index"
                        :value="item.code"
                        >{{ $t(item.name) }}</option
                      >
                    </template>
                  </select>
                  <div class="invalid-feedback">
                    {{ create.error.prefCode }}
                  </div>
                </div>
                <div class="col-form-label" v-if="create.confirm">
                  {{ $t(getPrefName(create)) }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">
                {{ $t('住所1') }}
                <span class="text-danger">{{ $t('必須') }}</span>
              </label>
              <div class="col-sm-9">
                <div class="input-group" v-if="!create.confirm">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('京都市中京区')"
                    maxlength="200"
                    required
                    v-model="create.address1"
                    :class="{
                      'is-invalid': create.error.address1,
                    }"
                  />
                  <div class="invalid-feedback">
                    {{ create.error.address1 }}
                  </div>
                </div>
                <div class="col-form-label" v-if="create.confirm">
                  {{ create.address1 }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">
                {{ $t('住所2') }}
                <span class="text-danger">{{ $t('必須') }}</span>
              </label>
              <div class="col-sm-9">
                <div class="input-group" v-if="!create.confirm">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('新町通三条上ル町頭町112')"
                    maxlength="200"
                    required
                    v-model="create.address2"
                    :class="{
                      'is-invalid': create.error.address2,
                    }"
                  />
                  <div class="invalid-feedback">
                    {{ create.error.address2 }}
                  </div>
                </div>
                <div class="col-form-label" v-if="create.confirm">
                  {{ create.address2 }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">{{ $t('住所3') }}</label>
              <div class="col-sm-9">
                <div class="input-group" v-if="!create.confirm">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('菊三ビル3F')"
                    maxlength="200"
                    v-model="create.address3"
                    :class="{
                      'is-invalid': create.error.address3,
                    }"
                  />
                  <div class="invalid-feedback">
                    {{ create.error.address3 }}
                  </div>
                </div>
                <div class="col-form-label" v-if="create.confirm">
                  {{ create.address3 }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">
                {{ $t('TEL') }}
                <span class="text-danger">{{ $t('必須') }}</span>
              </label>
              <div class="col-sm-9">
                <div class="input-group" v-if="!create.confirm">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('075-585-5097')"
                    maxlength="20"
                    required
                    v-model="create.phoneNo"
                    :class="{
                      'is-invalid': create.error.phoneNo,
                    }"
                  />
                  <div class="invalid-feedback">{{ create.error.phoneNo }}</div>
                </div>
                <div class="col-form-label" v-if="create.confirm">
                  {{ create.phoneNo }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">{{ $t('FAX') }}</label>
              <div class="col-sm-9">
                <div class="input-group" v-if="!create.confirm">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('075-585-5097')"
                    maxlength="20"
                    v-model="create.faxNo"
                    :class="{
                      'is-invalid': create.error.faxNo,
                    }"
                  />
                  <div class="invalid-feedback">{{ create.error.faxNo }}</div>
                </div>
                <div class="col-form-label" v-if="create.confirm">
                  {{ create.faxNo }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">
                {{ $t('ご担当者名') }}
                <span class="text-danger">{{ $t('必須') }}</span>
              </label>
              <div class="col-sm-9">
                <div class="input-group" v-if="!create.confirm">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="128"
                    required
                    v-model="create.username"
                    :class="{
                      'is-invalid': create.error.username,
                    }"
                  />
                  <div class="invalid-feedback">
                    {{ create.error.username }}
                  </div>
                </div>
                <div class="col-form-label" v-if="create.confirm">
                  {{ create.username }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">
                {{ $t('利用規約') }}
                <span class="text-danger">{{ $t('必須') }}</span>
              </label>
              <div class="col-sm-9">
                <div class="input-group" style="height: 100%;">
                  <div
                    class="form-check form-check-inline"
                    :class="{ 'is-invalid': create.error.isAgreement }"
                  >
                    <input
                      type="checkbox"
                      id="isAgreement"
                      class="form-check-input"
                      required
                      v-model="create.isAgreement"
                      :disabled="create.confirm"
                      :class="{
                        'is-invalid': create.error.isAgreement,
                      }"
                    />
                    <label
                      for="isAgreement"
                      class="form-check-label"
                      v-html="$t(messages.isAgreement)"
                    ></label>
                  </div>
                  <div class="invalid-feedback">
                    {{ create.error.isAgreement }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center">
        <div class="mt-4 mb-4">
          <div v-if="create.confirm">
            <button
              type="button"
              class="btn btn-success mr-3"
              @click="createRegister()"
              :disabled="create.registration"
            >
              <div
                class="d-flex justify-content-center align-items-center mr-3"
                v-if="create.registration"
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              </div>
              {{ $t('登録') }}
            </button>
            <button
              class="btn btn-light"
              @click="create.confirm = false"
              :disabled="create.registration"
            >
              {{ $t('キャンセル') }}
            </button>
          </div>
          <div v-if="!create.confirm">
            <button
              type="button"
              class="btn btn-light"
              @click="createConfirm()"
              :disabled="create.registration"
            >
              {{ $t('確認') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'querystringify'
import country from '../../assets/json/country.json'
import pref from '../../assets/json/pref.json'
import language from '../../assets/json/language.json'

const query = qs.parse(location.search)
const defaultIsPurchaseTrial = query && query.isPurchaseTrial ? true : false
const defaultIsNoCard = query && query.isNoCard ? true : false

export default {
  name: 'signup',
  props: {
    isFree: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      country: country,
      pref: pref,
      messages: {
        header:
          '必須事項を入力しましたら、<a href="https://corp.monorevo.jp/buisiness/agreement/" target="_blank">利用規約</a>、<a href="https://corp.monorevo.jp/privacy/" target="_blank">プライバシーポリシー</a>をお読みのうえ、「確認」ボタンを押して下さい',
        isAgreement:
          '<a href="https://corp.monorevo.jp/buisiness/agreement/" target="_blank">利用規約</a>・<a href="https://corp.monorevo.jp/privacy/" target="_blank">プライバシーポリシー</a>に同意する',
      },
      isPurchaseTrial: defaultIsPurchaseTrial,
      create: {
        uid: '',
        uidConfirm: '',
        name: '',
        kana: '',
        isUseSmallLot: false,
        isUsePurchase: false,
        isUseInventory: false,
        isTrial: this.isFree,
        coupon: '',
        countryCode: 'JP',
        zipcode: '',
        prefCode: '',
        address1: '',
        address2: '',
        address3: '',
        phoneNo: '',
        faxNo: '',
        username: '',
        loginId: '',
        password: '',
        passwordConfirm: '',
        languageCode:
          language.map(v => v.code).indexOf(this.$i18n.locale) !== -1
            ? this.$i18n.locale
            : this.$i18n.fallbackLocale,
        isAgreement: false,
        ediToken: query.edi_token || '',
        error: {},
        registration: false,
        confirm: false,
        isNoCard: defaultIsNoCard,
      },
      isLoading: false,
      pageTitle: 'ものレボ会員登録',
    }
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  methods: {
    createConfirm() {
      const _c = this.create
      _c.error = {}

      if (!this.isFree) {
        const isUse = _c.isUseSmallLot || _c.isUseInventory || _c.isUsePurchase
        if (!isUse) {
          _c.error.isUse = this.$t('ご利用アプリを最低1つ選択して下さい')
        }
      }

      if (this.isEmpty(_c.uid)) {
        _c.error.uid = this.$t('入力して下さい')
      } else {
        if (!this.isEmail(_c.uid)) {
          _c.error.uid = this.$t('形式が正しくありません')
        }
      }

      if (this.isEmpty(_c.uidConfirm)) {
        _c.error.uidConfirm = this.$t('入力して下さい')
      } else {
        if (_c.uid !== _c.uidConfirm) {
          _c.error.uidConfirm = this.$t('メールアドレスと一致しません')
        }
      }

      if (this.isEmpty(_c.loginId)) {
        _c.error.loginId = this.$t('入力して下さい')
      }

      const passwordMinLength = 6
      if (this.isEmpty(_c.password)) {
        _c.error.password = this.$t('入力して下さい')
      } else {
        if (_c.password.length < passwordMinLength) {
          _c.error.password = this.$tc(
            'パスワードは{passwordMinLength}文字以上で入力して下さい',
            passwordMinLength,
            { passwordMinLength: passwordMinLength },
          )
        }
      }

      if (this.isEmpty(_c.passwordConfirm)) {
        _c.error.passwordConfirm = this.$t('入力して下さい')
      } else {
        if (_c.password !== _c.passwordConfirm) {
          _c.error.passwordConfirm = this.$t('パスワードと一致しません')
        }
      }

      if (this.isEmpty(_c.countryCode)) {
        _c.error.countryCode = this.$t('選択して下さい')
      }

      if (this.isEmpty(_c.name)) {
        _c.error.name = this.$t('入力して下さい')
      }

      if (_c.countryCode === 'JP') {
        if (this.isEmpty(_c.kana)) {
          _c.error.kana = this.$t('入力して下さい')
        } else {
          if (!this.isKana(_c.kana)) {
            _c.error.kana = this.$t('形式が正しくありません')
          }
        }
      }

      if (this.isEmpty(_c.zipcode)) {
        _c.error.zipcode = this.$t('入力して下さい')
      } else {
        if (!this.isZipcode(_c.zipcode)) {
          _c.error.zipcode = this.$t('形式が正しくありません')
        }
      }

      if (this.isEmpty(_c.prefCode)) {
        _c.error.prefCode = this.$t('選択して下さい')
      }

      if (this.isEmpty(_c.address1)) {
        _c.error.address1 = this.$t('入力して下さい')
      }

      if (this.isEmpty(_c.address2)) {
        _c.error.address2 = this.$t('入力して下さい')
      }

      if (this.isEmpty(_c.phoneNo)) {
        _c.error.phoneNo = this.$t('入力して下さい')
      } else {
        if (!this.isTel(_c.phoneNo)) {
          _c.error.phoneNo = this.$t('形式が正しくありません')
        }
      }

      if (!this.isEmpty(_c.faxNo)) {
        if (!this.isTel(_c.faxNo)) {
          _c.error.faxNo = this.$t('形式が正しくありません')
        }
      }

      if (this.isEmpty(_c.username)) {
        _c.error.username = this.$t('入力して下さい')
      }

      if (!_c.isAgreement) {
        _c.error.isAgreement = this.$t('同意が必要です')
      }

      _c.confirm = Object.keys(_c.error).length === 0
    },
    getCountryName(item) {
      const country =
        this.country.find(value => value.code === item.countryCode) || {}
      return country.name || ''
    },
    getPrefName(item) {
      const prefs = this.pref[item.countryCode] || []
      const pref = prefs.find(value => value.code == item.prefCode) || {}
      return pref.name || ''
    },
    async createRegister() {
      this.isLoading = true

      try {
        await this.$axios({
          method: 'post',
          url: `${this.$appConfig.CommonApiUrl}/company`,
          data: this.create,
        })

        const signupDonePath =
          (process.env.NODE_ENV !== 'development' ? '/base' : '') +
          '/auth/signupdone.html'
        window.location.href = signupDonePath
      } catch (e) {
        console.log(e)
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
      } finally {
        this.isLoading = false
      }
    },
  },
  watch: {
    'create.zipcode': function(zipcode) {
      let _c = this.create
      if (_c.countryCode != 'JP') return

      try {
        // NOTE: html上で直接scriptを呼び出している
        // eslint-disable-next-line no-undef
        new YubinBango.Core(zipcode, addr => {
          _c.prefCode = addr.region_id
            ? 'JP-' + ('0' + addr.region_id).slice(-2)
            : ''
          _c.address1 = addr.locality
          _c.address2 = addr.street
        })
      } catch (err) {
        // console.log(err)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.card {
  .card-body {
    font-size: 1.4rem;
  }
}
.btn {
  font-size: 1.4rem;
}
</style>
